// extracted by mini-css-extract-plugin
export var dataCell = "_p9-2";
export var dataRow = "_p9-0";
export var headerRow = "_p9-1";